module.exports = __webpack_public_path__ + "img/gjsing-logo-new.7961e953.png";